var _class, _PixFilterBanner;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import PixButton from './pix-button';
import PixIcon from './pix-icon';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let PixFilterBanner = (_class = (_PixFilterBanner = class PixFilterBanner extends Component {
  get displayTitle() {
    return Boolean(this.args.title);
  }
  get displayDetails() {
    return Boolean(this.args.details);
  }
  get displayClearFilters() {
    return Boolean(this.args.clearFiltersLabel);
  }
  get displayLoadFilters() {
    return Boolean(this.args.loadFiltersLabel);
  }
  get displayActionMenu() {
    return this.displayClearFilters || this.displayDetails || this.displayLoadFilters;
  }
  onSubmit(event) {
    if (this.args.onLoadFilters) {
      event.preventDefault();
      this.args.onLoadFilters(event);
    }
  }
}, setComponentTemplate(precompileTemplate("\n    <form {{on \"submit\" this.onSubmit}} class=\"pix-filter-banner\" ...attributes>\n      {{#if this.displayTitle}}\n        <p class=\"pix-filter-banner__title\">\n          <PixIcon @name=\"filter\" @plainIcon={{true}} class=\"pix-filter-banner__icon-title\" aria-hidden=\"true\" />\n          {{@title}}\n        </p>\n      {{/if}}\n\n      <div class=\"pix-filter-banner__container\">\n        <div class=\"pix-filter-banner__filter\">\n          {{yield}}\n        </div>\n\n        {{#if this.displayActionMenu}}\n          <div class=\"pix-filter-banner__action\">\n            {{#if this.displayDetails}}\n              <p>{{@details}}</p>\n            {{/if}}\n\n            {{#if this.displayLoadFilters}}\n              <PixButton @variant=\"primary\" @type=\"submit\" @size=\"small\">\n                {{@loadFiltersLabel}}\n              </PixButton>\n            {{/if}}\n\n            {{#if this.displayClearFilters}}\n              <PixButton class=\"pix-filter-banner__button\" @iconBefore=\"delete\" @variant=\"tertiary\" @size=\"small\" @triggerAction={{@onClearFilters}} @isDisabled={{@isClearFilterButtonDisabled}}>\n                {{@clearFiltersLabel}}\n              </PixButton>\n            {{/if}}\n          </div>\n        {{/if}}\n      </div>\n    </form>\n  ", {
  strictMode: true,
  scope: () => ({
    on,
    PixIcon,
    PixButton
  })
}), _PixFilterBanner), _PixFilterBanner), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _class);
export { PixFilterBanner as default };